"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoPause = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var VideoPause = function (props) {
    return ((0, jsx_runtime_1.jsxs)(material_1.SvgIcon, __assign({}, props, { viewBox: "0 0 32 32", children: [(0, jsx_runtime_1.jsx)("rect", { x: "8", y: "6", width: "5", height: "20", rx: "2.5", fill: "currentColor" }), (0, jsx_runtime_1.jsx)("rect", { x: "19", y: "6", width: "5", height: "20", rx: "2.5", fill: "currentColor" })] })));
};
exports.VideoPause = VideoPause;
